module.exports = __webpack_public_path__ + "static/media/black.c7677608.svg";